module.exports = __webpack_public_path__ + "img/card_bg.e97b1d8e.png";